module.exports = __webpack_public_path__ + "img/Lot13.1e2ae71f.jpg";